import {
  actions,
  createUtilityUserAsync,
  getUtilityDepartmentAnalysisAsync,
  getUtilityUsersDatatableAsync,
  getUtilityUsersLookupsAsync,
  getUtilityUserByIdAsync,
  getUtilityAnalysisDatatableAsync,
  getUtilityVoucherAsync,
  checkVoucherStateAsync,
  updatePaymentMethodAsync,
  updateUtilityUserActivationAsync,
} from './slices';

export const SalesActions = {
  ...actions,
  createUtilityUserAsync,
  getUtilityDepartmentAnalysisAsync,
  getUtilityUsersDatatableAsync,
  getUtilityUsersLookupsAsync,
  getUtilityUserByIdAsync,
  getUtilityAnalysisDatatableAsync,
  getUtilityVoucherAsync,
  checkVoucherStateAsync,
  updatePaymentMethodAsync,
  updateUtilityUserActivationAsync,
};

export * from './thunkHandlers';

export * from './types';
